import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa3fb68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "enquiry-page pt-227 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title mw-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Business Enquiry"),
  /*#__PURE__*/_createElementVNode("h2", null, "Contact Us for Business Opportunities")
], -1))
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name / Brand Name", -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "celebrity" }, "Select Celebrity", -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-4fa3fb68>Select Celebrity</option><option value=\"Sharanya Shetty\" data-v-4fa3fb68>Sharanya Shetty</option><option value=\"Rashmi Prabhakar\" data-v-4fa3fb68>Rashmi Prabhakar</option><option value=\"Aditi Prabhudeva\" data-v-4fa3fb68>Aditi Prabhudeva</option><option value=\"Reeshma Nanaiah\" data-v-4fa3fb68>Reeshma Nanaiah</option><option value=\"Parvati Nair\" data-v-4fa3fb68>Parvati Nair</option><option value=\"Sudhan D\" data-v-4fa3fb68>Sudhan D</option>", 7)
const _hoisted_15 = [
  _hoisted_8
]
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Enter your Enquiry Details", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("form", {
          class: "enquiry-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              id: "celebrity",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.celebrity) = $event)),
              required: ""
            }, _hoisted_15, 512), [
              [_vModelSelect, _ctx.celebrity]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("textarea", {
              id: "message",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.message]
            ])
          ]),
          _hoisted_20
        ], 32)
      ])
    ]),
    _createVNode(_component_MainFooter)
  ], 64))
}